module.exports = __webpack_public_path__ + "static/img/template_img_07.79a7489.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/template_img_07.jpg
// module id = 397
// module chunks = 0